import React from "react";
import NavigationMenu from "design-system/src/Navigation/NavigationMenu/NavigationMenu";
import { useTranslation } from "@src/hooks/useTranslation";

const LoginButtonFallback = () => {
  const { t } = useTranslation("Navigation");
  return <NavigationMenu icon="user" label={t("Me connecter", "Navigation")} />;
};

export default LoginButtonFallback;
